/// <reference lib="webworker" />

import { set } from 'idb-keyval';
import { compress } from './cache/compression.pure';

addEventListener(
  'message',
  ({ data }: MessageEvent<{ key: string; value: any }>) => {
    console.time('compressed' + data.key);
    const value = compress(data.value);
    console.timeEnd('compressed' + data.key);

    set(data.key, value).catch((err) => console.log('It failed!', err));
    postMessage('ok ' + data.key);
  }
);
